import React from 'react';
import { AppRouter } from './routes';
import { AuthProvider } from './context/authContext';
import { EstadoAppProvider } from './context/EstadoAppContext';
import { GeoProvider } from './context/GeoContext';
import { NuevaONGProvider } from './context/NuevaONGContext';
import { FormProvider } from './context/FormContext';
import { RedProvider } from './context/RedContext';
import { ReferentesProvider } from './context/ReferentesContext';
import { ThemeProvider } from './context/ThemeContext';

import './App.css';
import 'react-toastify/dist/ReactToastify.css';
//import { ToastContainer } from 'react-toastify';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <EstadoAppProvider>
            <GeoProvider>
              <NuevaONGProvider>
                <ReferentesProvider>
                  <RedProvider>
                    <FormProvider>
                      <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-200">
                        <AppRouter />
                      </div>                    
                    </FormProvider>
                  </RedProvider>
                  {/*<ToastContainer 
                    position="top-right" 
                    autoClose={3000}
                    style={{ zIndex: 99999 }}
                    containerStyle={{ zIndex: 99999 }}
                  />*/}
                </ReferentesProvider>
              </NuevaONGProvider>
            </GeoProvider>
          </EstadoAppProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
